import { render, staticRenderFns } from "./Errorpage.vue?vue&type=template&id=32da9d77&"
import script from "./Errorpage.vue?vue&type=script&lang=js&"
export * from "./Errorpage.vue?vue&type=script&lang=js&"
import style0 from "./Errorpage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Errorpage.vue"
export default component.exports